import styled from '@emotion/styled';

export const PageContainer = styled.div`
    padding: 32px;
    max-width: 100%;
    overflow-x: auto;
`;

export const Title = styled.h1`
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 8px 0;
    color: ${({ theme }) => theme.color.black200};
`;

export const Subtitle = styled.p`
    font-size: 14px;
    color: ${({ theme }) => theme.color.black400};
    margin: 0 0 24px 0;
    line-height: 1.5;
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
`;

export const ErrorMessage = styled.p`
    color: ${({ theme }) => theme.color.red200};
    font-size: 14px;
    margin: 8px 0 0 0;
`;
